module.exports = __webpack_public_path__ + "img/e_1_8_g.f22bd8c0.png";